<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
    <div class="colored_bk">
    <div class="container">

    <div class="mt-2 d-flex justify-content-center flex-column align-items-center" >
        <div>
            <div>
            <div class="title">邀请好友</div>
        
        <div class="mt-1 d-flex justify-content align-items-center"> 1. 邀请链接：https://liangks.com/home?code={{ promotion_code }}
            <button class="btn normalBtn ml-1" @click="copy">
               复制链接
            </button>
        </div>
        <div >
          <div v-if="promotion_qr==undefined" class="d-flex justify-content align-items-center">
            2. <button class="btn normalBtn gap" @click="displayQr">生成邀请海报</button></div>

            <div v-else>
            <div>
              2.分享邀请海报，电脑端，邮件保存，手机端，长按图片保存
            </div> 
            <div>
              <img :src="promotion_qr" style="width: 5rem;">
            </div>
          </div>
          </div>
         
          
      
        </div>

            <div class="title mt-3" >我邀请的用户：共{{user_count}}人</div>
        
        <div class="mt-1" v-if="users!=undefined">
            <div class="row" >
                <div class="col-m p-1 card m-1" v-for="(user,index) in users" :key="index">
                   <div>
                    用户{{index+1}}
                   </div>
                   <div class="mt-1">
                    注册于{{ localDatetime(user.createdDate) }}
                   </div>
                   <div class="mt-1 topBorder pt-1">
                    绑定的小红书账号数：{{ user.accounts.length }}
                   </div>
                   <div>
                    <div v-for="(account,acc_index) in user.accounts" :key="acc_index" class="mt-1">
                        <div>
                            <div>
                                <div v-if="account.user_info!=undefined&&account.user_info.nickname!=undefined">{{acc_index+1}}.{{  account.user_info.nickname}}</div>
                                <div v-else>{{acc_index+1}}.新用户</div>
                            </div>
                            <div>
                                <div v-if="account.auth!=undefined&& account.auth.type=='free'">免费试用中</div>
                                <div v-else>
                                    <div v-if="account.auth!=undefined">
                                    <div class="border:1px solid #434343">
                                        <div v-for="(paid,p_index) in account.auth.records" :key="p_index" class="d-flex justify-content-between">
                                            <div>{{ paid.description }}</div>
                                            <div class="ml-1">￥{{ paid.amount }}</div>
                                            <div class="ml-1">{{localDatetime(paid.createdDate) }}</div>
                                        </div>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>
                   </div>
                </div>
            </div>
        </div>


        <div class="mt-1 mb-1 d-flex justify-content" v-if="pages>1">
          <div v-for="(n,index) in pages" :key="index">
            <div :class="n==current_page?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>
        </div>
      
    </div>

    
    
      <!-- <div class="d-flex flex-column justify-content-center align-items-center">
        <img :src="promotion_qr" class="qr">
        <div>保存此二维码并分享</div>
      </div> -->
    </div>
    </div>
  </template>
  
  <script>
import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  import moment from 'moment'
  import { Clipboard } from "v-clipboard";
  // import AccountPageVue from './AccountPage.vue';
  export default {
    data() {
      return {
        role:0,
        isLoading:false,
        needLogin:false,
        router:'account',
        showqr:false,
        promotion_qr:null,
        promotion_code:null,
        spinnerColor:"#262626",
        pages:0,
        per_page:20,
        current_page:0,
        users:null,
        user_count:0
      };
    },
    components: {
        GridLoader
    },
    computed: {
  localDatetime() {
    return (datetimeString) => {
      let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
      return beijingTime
      
    }
  }
},
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
          this.role=localStorage.getItem('role');
  
            if(token==undefined || token==null ||token=='')
            {
              this.needLogin=true
            }
            else
            {
              this.needLogin=false;
            }
    
            var current=this.$route.path
            this.router=current.replace('/index/','')

            this.getPromotionCode();
            this.getInvitesCount();
       
           
    },
  
    setup(){
      
      var token=localStorage.getItem('sessionToken')
      axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
   },
    methods: {
      back(){
        this.$router.back(-1)
      },
      displayQr(){
        this.showqr=true;
        this.getQr();
        
      },

      copy(){
        Clipboard.copy("https://liangks.com/home?code="+this.promotion_code);
      },
      async getPromotionCode(){
        try{
            
         this.isLoading=true;
          const response = await axios.get(this.domain+'xhs/get_promotion_code');
  
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
              this.promotion_code=data.promotion_code           
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
        finally{
            this.isLoading=false;
        }
       
       
      },
      changePage(n){
        if(this.current_page==n-1)
        {
            return
        }
        this.current_page=n-1
        this.getInvites()

      },

      async getInvitesCount(){
        try{
            
         this.isLoading=true;
          const response = await axios.get(this.domain+'xhs/get_invites_count');
  
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
              var count=data.count
              this.user_count=count;
              this.pages=Math.ceil(count/this.per_page)
              this.current_page=0;   
              if(count>0)
              {
                this.getInvites()
              }
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
        finally{
            this.isLoading=false;
        }
       
       
      },


      async getInvites(){
        try{
            
         this.isLoading=true;
          const response = await axios.get(this.domain+'xhs/get_invites?times='+this.current_page.toString()+'&count='+this.per_page.toString());
  
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
              this.users=data.users
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
        finally{
            this.isLoading=false;
        }
       
       
      },
  
  
    

      async getQr(){
        try{
  
          const response = await axios.get(this.domain+'xhs/get_promotion_qr');
  
          var data=response.data
          if(data.status=='Suc')
          {
              this.promotion_qr=data.qr           
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
       
       
      },
  
    }
  };
  </script>
  
  <style scoped>
  
  #navbar {
   
    width: 100%;
    background-color: #ffffff;
  }
  .selectedFont{
    color: #3b64ff;
  
   
   
  }
  .unselectedFont{
    color: #262626;
  
  
  }
  
  .icon{
    width:0.3rem;
    height:0.3rem;
  }
  .gap{
    margin-top: 0.05rem;
  }
  .left-center {
      position: fixed;
      top: 50%;
      left: 0.2rem;
      transform: translateY(-50%);
      
  }
  
  .leftBox img{
    width:0.3rem;
  }
  .iconTitle{
    font-size: 0.15rem;
    color:#5E6772;
  }
  </style>
  